import { render, staticRenderFns } from "./CreateTournamentStage.vue?vue&type=template&id=dc15e2a4"
import script from "./CreateTournamentStage.vue?vue&type=script&lang=js"
export * from "./CreateTournamentStage.vue?vue&type=script&lang=js"
import style0 from "./CreateTournamentStage.vue?vue&type=style&index=0&id=dc15e2a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports